module.exports = __webpack_public_path__ + "media/images/mypage/mypage_box_bg-267e8a0474b5bafd9f326a790408092a.png";